import * as SecureStore from "expo-secure-store";

async function Save(key: string, value: any) {
  await SecureStore.setItemAsync(key, value);
}

async function Get(key: string) {
  return await SecureStore.getItemAsync(key);
}

async function Clear(key: string) {
  return await SecureStore.deleteItemAsync(key)
}

export { Save, Get, Clear };
